<div class="container">
  <h2 class="title">【レポート(β)機能 移行のお知らせ】</h2>
  <div class="message">
    <p>
      本機能は Qoala Version2 に「分析（β）」として移行しております。<br>
      ▶ Version2 ログインURL：
      <a [href]="v2FrontUrl" target="_blank" rel="noopener">{{ v2FrontUrl }}</a>
    </p>
    <p>
      ログイン方法は下記記事をご参照ください。<br>
      ▶ Version2 ログイン方法：
      <a href="https://support.qoala.jp/portal/ja/kb/articles/v2-login" target="_blank" rel="noopener">
        https://support.qoala.jp/portal/ja/kb/articles/v2-login
      </a>
    </p>
    <div class="notes">
      <p>※ サポートサイトはユーザー様ご自身でのアカウント開設が必要となりますので、まだ開設されていない場合はログイン画面の右側にある「未登録の場合：登録する」よりお手続きをお願いいたします</p>
      <p>※ アカウントは存在しているもののパスワードが不明な場合は、同じく画面右の「パスワードを忘れた場合：リセットする」より再設定をお願いします</p>
    </div>
  </div>
</div>
